
        <svg #svgContainer
             [style.background-color]="this.backgroundColor || this.whiteboardOptions.backgroundColor"></svg>
    